import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';

/**
 * EnadisCompareComponent
 * @description Wrapper to display "Enadis compare" views
 */
@Component({
  selector: 'app-enadis-compare',
  templateUrl: './enadis-compare.component.html',
  styleUrls: ['./enadis-compare.component.scss']
})
export class EnadisCompareComponent implements OnInit {

  /**
   * Init component, inject services
   * @param dialog MatDialog service injector
   */
  constructor(public dialog: MatDialog) { }

  /** Angular life cycle OnInit component */
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/enadis-compare/enadis-compare.component.ts